import {MerchantPlatformSettings} from "./payment.types";

export enum CreditCard {
    Visa = 'Visa',
    Mastercard = 'MasterCard',
    AmericanExpress = 'AmericanExpress',
    Discover = 'Discover'
}

export interface CustomerBillingDetails {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    address: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
    lastFourDigits?: string;
    merchantPlatformCredentials?: MerchantPlatformSettings;
}

export interface CustomerBillingInfo {
    address: string;
    city: string;
    state: string;
    postalCode: string;
    country?: string;
}

export interface CustomerBookingDetails {
    id: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    email2?: string;
    phone?: string;
    phone2?: string;
    fax?: string;
    address?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    creditCardNumber?: string;
}
